<template>
  <div class="ex-checkpoint-badge">
    <v-chip :class="classes">
        <span :class="textClasses" class="prop-status-label">{{ level }} Level</span>
    </v-chip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
// Props definition
const props = defineProps({
  level: {
    type: String,
    validator: function (value) {
      return ['Apprentice', 'Professional', 'Coach', 'Master'].indexOf(value) !== -1;
    },
  }
});

const classes = computed(() => {
  const levelClass = `checkpoint-badge--${props.level}`;
  return {
    [levelClass]: true,
  };
});

const textClasses = computed(() => {
  return {
    [`checkpoint-text--${props.level}`]: true,
  };
});
</script>

<style>
.ex-checkpoint-badge {
  display: flex;
  align-items: center;
}

.ex-checkpoint-badge .checkpoint-badge--Apprentice {
  border-radius: 8px !important;
  border: 1px solid;
  border-color:#E58700 !important;
  background-color: #FFF5D3 !important;
  padding: 18px 36px;
}

.ex-checkpoint-badge .checkpoint-badge--Professional {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #00B813 !important;
  background-color: #F3FFF9 !important;
  padding: 18px 32px;
}

.ex-checkpoint-badge .checkpoint-badge--Coach {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #00A3FF !important;
  background-color: #EFFEFF !important;
  padding: 18px 49px;
}

.ex-checkpoint-badge .checkpoint-badge--Master {
  border-radius: 8px !important;
  border: 1px solid;
  border-color: #2E1EC1 !important;
  background-color: #F2F3FF !important;
  padding: 18px 47.5px;
}

.ex-checkpoint-badge .checkpoint-text--Apprentice {
  color: #E58700 !important;
}

.ex-checkpoint-badge .checkpoint-text--Professional {
  color: #00B813 !important;
}

.ex-checkpoint-badge .checkpoint-text--Coach {
  color: #00A3FF !important;
}

.ex-checkpoint-badge .checkpoint-text--Master {
  color: #2E1EC1 !important;
}

.ex-checkpoint-badge .prop-status-label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}

.checkpoint-badge--Apprentice:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Professional:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Coach:hover:before {
  opacity: 0 !important;
}

.checkpoint-badge--Master:hover:before {
  opacity: 0 !important;
}
</style>

  